/**
 * Detect if we're running on a subdomain (hr.* / continuum.*).
 * Returns "hr" | "continuum" | null.
 * In preview/dev where we only have one hostname, returns null.
 */
export function detectSubdomain() {
  if (typeof window === "undefined") return null;
  const host = window.location.hostname.toLowerCase();
  // Skip localhost/preview single-host environments
  if (host === "localhost" || host.startsWith("127.") || host.endsWith(".preview.emergentagent.com") || host.endsWith(".emergent.host")) {
    return null;
  }
  if (host.startsWith("hr.")) return "hr";
  if (host.startsWith("continuum.")) return "continuum";
  return null;
}
